import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class DialogBase extends Vue {
  @Prop({ default: null })
  protected value!: boolean;

  protected innerValue: boolean = this.value;

  @Watch('value')
  protected onValueChanged(newVal: boolean): void {
    this.innerValue = newVal;
  }

  @Watch('innerValue')
  protected onInnerValueChanged(newVal: boolean): void {
    this.$emit('input', newVal);
  }
}
